<template>
  <div class="notice-detail-box-in">
    <!-- <div
      :class="
        `purchase-class ${data.schemeClass === '1' ? 'equipment' : 'materials'}`
      "
    >
      {{ $t("page.content.subpackage") }}{{ $t("page.content.purchase") }}
    </div> -->
    <div
      style="font-size: 14px; font-weight: 500"
      :title="`${data.noticeTitle}`"
    >
      {{ data.schemeCode }}
    </div>
    <div class="scheme-name ell-2" :title="`${data.noticeTitle}`">
      {{ data.noticeTitle }}
    </div>
    <div class="scheme-type">
      {{ data.purchaseTypeName }}
    </div>
    <!-- <div
      class="class-name ell color-1"
      :title="
        `${
          data.bigClassName[0] ? data.bigClassName.join(',') : data.engineerType
        }`
      "
    > -->
    <div class="class-name ell color-1" :title="`${data.engineerTypeName}`">
      <!-- {{
        data.bigClassName[0]
          ? data.bigClassName.join(",")
          : $t("page.content.other")
      }} -->
      {{ data.engineerTypeName }}
    </div>
    <ul class="notice-detail-box-ul">
      <li>
        <span
          class="notice-detail-label ell"
          :title="$t('page.content.projectName')"
          >{{ $t("page.content.projectName") }}</span
        >：
        <span class="ellipsis notice-detail-name" :title="data.schemeName">{{
          data.schemeName
        }}</span>
      </li>
      <li v-if="data.purchaseType !== '0' && data.purchaseType !== '50'">
        <!--招标采购（公开招标和协议类公开招标）不显示供应商名称-->
        <span
          class="notice-detail-label ell"
          :title="$t('page.content.supplierName')"
          >{{ $t("page.content.supplierName") }}</span
        >：
        <span class="ellipsis notice-detail-name" :title="supName">{{
          supName
        }}</span>
      </li>
      <li>
        <span
          class="notice-detail-label ell"
          :title="$t('page.content.publishTime')"
          >{{ $t("page.content.publishTime") }}</span
        >：
        <span
          class="ellipsis notice-detail-name"
          :title="moment(data.noticeStartTime).format('YYYY-MM-DD HH:mm')"
          >{{ moment(data.noticeStartTime).format("YYYY-MM-DD HH:mm") }}</span
        >
      </li>
      <li>
        <template v-if="!!data.packNum">
          <span
            class="notice-detail-label ell"
            :title="$t('page.content.packageNum')"
            >{{ $t("page.content.packageNum") }}</span
          >：
          <span class="ellipsis notice-detail-name" :title="data.packNum">{{
            data.packNum
          }}</span>
        </template>
      </li>
    </ul>

    <div class="dotted-line"></div>
    <div class="notice-detail-state">
      <!-- <i class="el-icon-time notice-icon-time-blue"></i> -->
      <span>
        {{ $t("page.content.joinStatus") }}：
        <span
          v-if="loginInfo && loginInfo.name"
          :class="data.isJoin == '1' ? 'join' : ''"
          >{{ data.isJoin == "0" ? "未参与" : "已参与" }}
        </span>
        <span v-else 
          >登录后可见
        </span>
      </span>
    </div>
    <!--<div class="notice-detail-state">{{ data.noticeStatusName }}</div>-->
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "noticeItemBlock",
  data() {
    return {
      moment,
      supName: "", //供应商名称
    };
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    source: {
      type: String,
      default: "default",
    },
  },
  computed: {
    loginInfo() {
      return this.$store.getters.getLoginInfo;
    },
  },
  mounted() {
    this.supName = localStorage.getItem("supInfo")
      ? JSON.parse(localStorage.getItem("supInfo")).supName
      : "";
  },
};
</script>

<style scoped lang="scss">
.pt3 {
  padding-top: 3px;
}
.days {
  color: red;
  padding: 0px 3px;
}
.notice-icon-time-blue {
  color: #0089ef;
  font-size: 14px;
}
</style>
